<template>
  <svg
    v-if="icon === 'pages-projects'"
    :width="width ? width : 24"
    :height="height ? height : 24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M15 6.5C14.448 6.5 14 6.052 14 5.5V4H10V5.5C10 6.052 9.552 6.5 9 6.5C8.448 6.5 8 6.052 8 5.5V4C8 2.897 8.897 2 10 2H14C15.103 2 16 2.897 16 4V5.5C16 6.052 15.552 6.5 15 6.5Z"
        :fill="color"
      />
      <path
        d="M12.71 15.3801C12.53 15.4501 12.27 15.5001 12 15.5001C11.73 15.5001 11.47 15.4501 11.23 15.3601L0 11.6201V19.2501C0 20.7701 1.23 22.0001 2.75 22.0001H21.25C22.77 22.0001 24 20.7701 24 19.2501V11.6201L12.71 15.3801Z"
        :fill="color"
      />
      <path
        d="M24 7.75V10.04L12.24 13.96C12.16 13.99 12.08 14 12 14C11.92 14 11.84 13.99 11.76 13.96L0 10.04V7.75C0 6.23 1.23 5 2.75 5H21.25C22.77 5 24 6.23 24 7.75Z"
        :fill="color"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'pages-projects-all'"
    :width="width ? width : 14"
    :height="height ? height : 14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M8.75002 3.79169C8.42803 3.79169 8.16669 3.53035 8.16669 3.20835V2.33335H5.83337V3.20835C5.83337 3.53035 5.57203 3.79169 5.25003 3.79169C4.92803 3.79169 4.6667 3.53035 4.6667 3.20835V2.33335C4.6667 1.68994 5.18995 1.16669 5.83337 1.16669H8.16669C8.81011 1.16669 9.33336 1.68994 9.33336 2.33335V3.20835C9.33336 3.53035 9.07202 3.79169 8.75002 3.79169Z"
        :fill="color"
      />
      <path
        d="M7.41417 8.97166C7.30917 9.01249 7.1575 9.04166 7 9.04166C6.8425 9.04166 6.69083 9.01249 6.55083 8.95999L0 6.77832V11.2292C0 12.1158 0.7175 12.8333 1.60417 12.8333H12.3958C13.2825 12.8333 14 12.1158 14 11.2292V6.77832L7.41417 8.97166Z"
        :fill="color"
      />
      <path
        d="M14 4.52085V5.85669L7.14 8.14335C7.09333 8.16085 7.04667 8.16669 7 8.16669C6.95333 8.16669 6.90667 8.16085 6.86 8.14335L0 5.85669V4.52085C0 3.63419 0.7175 2.91669 1.60417 2.91669H12.3958C13.2825 2.91669 14 3.63419 14 4.52085Z"
        :fill="color"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'pages-projects-statistic'"
    :width="width ? width : 14"
    :height="height ? height : 14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.84766 0C7.62095 0 7.4375 0.183449 7.4375 0.410156V6.17969C7.4375 6.40639 7.62095 6.58984 7.84766 6.58984H13.5898C13.8166 6.58984 14 6.40639 14 6.17969C14 2.78709 11.2402 0 7.84766 0Z"
      :fill="color"
    />
    <path
      d="M8.60748 13.0803L6.61719 7.7458V2.07812C6.61719 1.85142 6.43374 1.66797 6.20703 1.66797C2.81444 1.66797 0 4.42772 0 7.82031C0 11.2129 2.81444 14 6.20703 14C6.94963 14 7.67662 13.8682 8.36757 13.6087C8.57946 13.5289 8.68681 13.2926 8.60748 13.0803Z"
      :fill="color"
    />
    <path
      d="M13.5898 7.41016H7.84766C7.71307 7.41016 7.58732 7.47625 7.5104 7.5868C7.43389 7.69735 7.41628 7.83833 7.46353 7.9645L9.47986 13.3687C9.5183 13.4705 9.59522 13.553 9.69456 13.5979C9.79395 13.6431 9.90595 13.6469 10.0086 13.6083C12.3958 12.7098 14 10.3678 14 7.82031C14 7.59361 13.8165 7.41016 13.5898 7.41016Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'pages-projects-archive'"
    :width="width ? width : 14"
    :height="height ? height : 14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2169 3.71082H2.78314C1.93977 3.71082 1.26507 4.38551 1.26507 5.22888V12.4819C1.26507 13.3252 1.93977 13.9999 2.78314 13.9999H11.2169C12.0602 13.9999 12.7349 13.3252 12.7349 12.4819V5.22888C12.7349 4.38551 12.0602 3.71082 11.2169 3.71082ZM9.41206 7.8096C9.41206 8.09635 9.19278 8.31562 8.90603 8.31562H5.09398C4.80724 8.31562 4.58796 8.09635 4.58796 7.8096V6.52767C4.58796 6.24093 4.80724 6.02165 5.09398 6.02165C5.38073 6.02165 5.60001 6.24093 5.60001 6.52767V7.30358H8.40001V6.52767C8.40001 6.24093 8.61929 6.02165 8.90603 6.02165C9.19278 6.02165 9.41206 6.24093 9.41206 6.52767V7.8096Z"
      :fill="color"
    />
    <path
      d="M11.2169 1.85541H2.78314C2.49639 1.85541 2.27712 2.07468 2.27712 2.36143C2.27712 2.64818 2.49639 2.86746 2.78314 2.86746H11.2169C11.5036 2.86746 11.7229 2.64818 11.7229 2.36143C11.7229 2.07468 11.5036 1.85541 11.2169 1.85541Z"
      :fill="color"
    />
    <path
      d="M10.3735 0H3.62651C3.33976 0 3.12048 0.219277 3.12048 0.506025C3.12048 0.792773 3.33976 1.01205 3.62651 1.01205H10.3735C10.6602 1.01205 10.8795 0.792773 10.8795 0.506025C10.8795 0.219277 10.6602 0 10.3735 0Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'pages-projects-sales'"
    :width="width ? width : 24"
    :height="height ? height : 24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M23.3077 22.6132H22.3846V5.07483C22.3846 4.43854 21.867 3.9209 21.2307 3.9209H17.5384C16.9023 3.9209 16.3846 4.43854 16.3846 5.07483V22.6132H15V8.76715C15 8.13086 14.4824 7.61322 13.8461 7.61322H10.1539C9.51764 7.61322 9 8.13086 9 8.76715V22.6132H7.61536V12.4595C7.61536 11.8232 7.09772 11.3055 6.46161 11.3055H2.76929C2.133 11.3055 1.61536 11.8232 1.61536 12.4595V22.6132H0.692322C0.309998 22.6132 0 22.9232 0 23.3055C0 23.6879 0.309998 23.9979 0.692322 23.9979H23.3077C23.69 23.9979 24 23.6879 24 23.3055C24 22.9232 23.69 22.6132 23.3077 22.6132Z"
        :fill="color"
      />
      <path
        d="M3.23863 7.9054C3.51878 8.15131 3.94762 8.11945 4.20653 7.85138L9.46422 2.40601V4.59576C9.46422 4.96857 9.75059 5.28937 10.123 5.30695C10.5206 5.32562 10.8489 5.00885 10.8489 4.61536V0.692322C10.8489 0.309998 10.5389 0 10.1565 0H6.48381C6.11101 0 5.79021 0.28656 5.77263 0.658814C5.75395 1.05634 6.07072 1.38464 6.46422 1.38464H8.5258L3.19688 6.90381C2.92351 7.18671 2.93962 7.64264 3.23863 7.9054Z"
        :fill="color"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'pages-projects-sales-all'"
    :width="width ? width : 14"
    :height="height ? height : 14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M3.91905 10.7829H1.64951V5.70805C1.64951 5.58175 1.75188 5.47937 1.87818 5.47937H3.69037C3.81667 5.47937 3.91905 5.58175 3.91905 5.70805V10.7829Z"
        :fill="color"
      />
      <path
        d="M8.13482 10.7829H5.86528V4.70768C5.86528 4.58138 5.96766 4.479 6.09396 4.479H7.90615C8.03245 4.479 8.13482 4.58138 8.13482 4.70768V10.7829Z"
        :fill="color"
      />
      <path
        d="M12.3505 10.7829H10.081V6.07261C10.081 5.94631 10.1833 5.84393 10.3096 5.84393H12.1218C12.2481 5.84393 12.3505 5.94631 12.3505 6.07261V10.7829Z"
        :fill="color"
      />
      <path
        d="M13.589 12.4113H0.411039C0.184036 12.4113 0 12.2272 0 12.0002C0 11.7732 0.184036 11.5892 0.411039 11.5892H13.589C13.816 11.5892 14 11.7732 14 12.0002C14 12.2272 13.816 12.4113 13.589 12.4113Z"
        :fill="color"
      />
      <path
        d="M13.8279 3.15284C13.8415 2.98106 13.7414 2.77011 13.5121 2.71676L12.1841 2.39396C11.9634 2.34016 11.7412 2.47567 11.6876 2.69626C11.634 2.91685 11.7693 3.13914 11.9899 3.19274L12.3655 3.28405L11.3007 3.94114L7.26333 1.6426C7.14725 1.57648 7.00618 1.57092 6.88533 1.62772L2.87211 3.51144L0.953654 2.3141C0.761095 2.19383 0.507539 2.25259 0.387323 2.44517C0.267136 2.63773 0.325832 2.89129 0.518418 3.0115L2.62667 4.32724C2.74496 4.40109 2.89266 4.40991 3.01893 4.35064L7.04178 2.46241L11.1059 4.77615C11.2116 4.83161 11.359 4.86036 11.5251 4.76873L12.8159 3.97216L12.7299 4.37476C12.6353 4.91029 13.3934 5.06237 13.5339 4.54646L13.8188 3.21212C13.822 3.1934 13.8232 3.19603 13.8279 3.15284Z"
        :fill="color"
      />
    </g>
  </svg>
  <svg
      v-else-if="icon === 'pages-projects-reports'"
      :width="width ? width : 18"
      :height="height ? height : 18"
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
  >
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 0C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V21C0 21.7956 0.31607 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H15C15.7957 24 16.5587 23.6839 17.1213 23.1213C17.6839 22.5587 18 21.7956 18 21V8.121C17.9998 7.32542 17.6836 6.56248 17.121 6L12 0.879C11.4375 0.316352 10.6746 0.000169912 9.879 0H3ZM6 15C6 14.6022 5.84196 14.2206 5.56066 13.9393C5.27936 13.658 4.89783 13.5 4.5 13.5C4.10218 13.5 3.72064 13.658 3.43934 13.9393C3.15804 14.2206 3 14.6022 3 15V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21C4.89783 21 5.27936 20.842 5.56066 20.5607C5.84196 20.2794 6 19.8978 6 19.5V15ZM9 10.5C9.39783 10.5 9.77936 10.658 10.0607 10.9393C10.342 11.2206 10.5 11.6022 10.5 12V19.5C10.5 19.8978 10.342 20.2794 10.0607 20.5607C9.77936 20.842 9.39783 21 9 21C8.60218 21 8.22064 20.842 7.93934 20.5607C7.65804 20.2794 7.5 19.8978 7.5 19.5V12C7.5 11.6022 7.65804 11.2206 7.93934 10.9393C8.22064 10.658 8.60218 10.5 9 10.5ZM15 9C15 8.60218 14.842 8.22064 14.5607 7.93934C14.2794 7.65804 13.8978 7.5 13.5 7.5C13.1022 7.5 12.7206 7.65804 12.4393 7.93934C12.158 8.22064 12 8.60218 12 9V19.5C12 19.8978 12.158 20.2794 12.4393 20.5607C12.7206 20.842 13.1022 21 13.5 21C13.8978 21 14.2794 20.842 14.5607 20.5607C14.842 20.2794 15 19.8978 15 19.5V9Z"
        :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconsPagesProjects',
  props: {
    icon: String,
    color: {
      type: String,
      default: '#A2D5F1',
    },
    width: {
      type: [String, Number],
      default: null,
    },
    height: {
      type: [String, Number],
      default: null,
    },
  },
}
</script>

<style scoped></style>
